import { z } from 'zod';
// Single source of truth for the agent step limit (maxSteps): the default
// applied when neither the user nor the conversation sets a value, and the
// bounds accepted by the API. Shared by the resolution layer, the Zod request
// schemas, and the settings UI so the three never drift.
export const MAX_STEPS = {
    default: 25,
    min: 1,
    max: 100
};
// Reusable schema for an explicit maxSteps value (not the patch `null` sentinel).
export const MaxStepsSchema = z.number().int().min(MAX_STEPS.min).max(MAX_STEPS.max);
